import React from "react";

const Topbar = () => null;

export default Topbar;
